<template>
    <TableLayout :permissions="['business:interfacelog:query']">
        <!-- 搜索表单 -->
        <el-form ref="searchForm" slot="search-form" :model="searchForm" label-width="100px" inline>
            <el-form-item label="接口名称" prop="name">
                <el-input v-model="searchForm.name" placeholder="请输入接口名称" @keypress.enter.native="search"></el-input>
            </el-form-item>
            <el-form-item label="类型" prop="type">
                <el-select v-model="searchForm.type" @change="search" placeholder="请选择">
                    <el-option label="调用" value="0"></el-option>
                    <el-option label="推送接受" value="1"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="起始时间" prop="startDate">
                <el-date-picker
                    @change="seleTime"
                    v-model="time"
                    type="datetimerange"
                    format="yyyy-MM-dd HH:mm:ss"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期">
                </el-date-picker>
            </el-form-item>
            <section>
                <el-button type="primary" @click="search">搜索</el-button>
                <el-button @click="reset">重置</el-button>
            </section>
        </el-form>
        <!-- 表格和分页 -->
        <template v-slot:table-wrap>
            <el-table
                v-loading="isWorking.search"
                :data="tableData.list"
                stripe
            >
                <el-table-column prop="name" label="接口名称" min-width="180px"></el-table-column>
                <el-table-column prop="url" label="地址信息" min-width="180px"></el-table-column>
                <el-table-column label="类型" min-width="100px">
                    <template slot-scope="{row}">
                        <span v-if="row.type == 0">调用</span>
                        <span v-if="row.type == 1">推送接收</span>
                    </template>
                </el-table-column>
                <el-table-column label="平台" min-width="100px">
                    <template slot-scope="{row}">
                        <span v-if="row.plat == 0">海康安防平台</span>
                        <span v-if="row.plat == 1">ERP系统</span>
                    </template>
                </el-table-column>
                <el-table-column prop="request" label="请求参数" min-width="100px">
                    <template slot-scope="{row}">
                        <el-button type="text" @click="$refs.operaInterfaceLogWindow.open('请求参数', {content: row.request})">查看</el-button>
                    </template>
                </el-table-column>
                <el-table-column prop="repose" label="响应参数" min-width="100px">
                    <template slot-scope="{row}">
                        <el-button type="text" @click="$refs.operaInterfaceLogWindow.open('响应参数', {content: row.repose})">查看</el-button>
                    </template>
                </el-table-column>
                <el-table-column prop="createDate" label="创建时间" min-width="100px"></el-table-column>
            </el-table>
            <pagination
                @size-change="handleSizeChange"
                @current-change="handlePageChange"
                :pagination="tableData.pagination"
            >
            </pagination>
        </template>
        <!-- 新建/修改 -->
        <OperaInterfaceLogWindow ref="operaInterfaceLogWindow" @success="handlePageChange"/>
    </TableLayout>
</template>

<script>
  import BaseTable from '@/components/base/BaseTable'
  import TableLayout from '@/layouts/TableLayout'
  import Pagination from '@/components/common/Pagination'
  import OperaInterfaceLogWindow from '@/components/business/OperaInterfaceLogWindow'
  export default {
    name: 'InterfaceLog',
    extends: BaseTable,
    components: { TableLayout, Pagination, OperaInterfaceLogWindow },
    data () {
      return {
        // 搜索
        searchForm: {
          name: '',
          type: '',
          endDate: '',
          startDate: ''
        },
        time: []
      }
    },
    created () {
      this.config({
        module: '三方平台接口交互记录',
        api: '/business/interfaceLog',
        'field.id': 'id',
        'field.main': 'id'
      })
      this.search()
    },
    methods: {
      seleTime (e) {
        this.searchForm.startDate = e[0]
        this.searchForm.endDate = e[1]
        this.search()
      },
      reset () {
        this.$refs.searchForm.resetFields()
        this.searchForm.startDate = ''
        this.searchForm.endDate = ''
        this.time = []
        this.search()
      }
    }
  }
</script>
